import { HexColorPicker } from "react-colorful";
import ModalWrapper from "../ModalWrapper"

const ColorModal = ({ isOpen, setIsOpen, color, colorRef, onColorChange }) => {
  return (
    <ModalWrapper 
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title="Select Color"
    >
      <div style={{ display: 'flex', justifyContent: 'center' }}>
          <HexColorPicker 
            color={color} 
            onChange={onColorChange} 
            onPointerUp={() => {
              colorRef.current = color
            }}
          />
      </div>
    </ModalWrapper>
  )
}

export default ColorModal